import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import { Navbar } from './components/Navbar';
import { LandingPage } from './pages/LandingPage';
import { MenuPage } from './pages/MenuPage';
import { CartPage } from './pages/CartPage';
import { LoginPage } from './pages/LoginPage';
import { SignupPage } from './pages/SignupPage';
import { UserDashboard } from './pages/UserDashboard';
import { OrderTrackingPage } from './pages/OrderTrackingPage';
import { AdminDashboard } from './pages/AdminDashboard';
import { QRCodePage } from './pages/QRCodePage';
import Footer from "./components/Footer";
import { OrderNotifier } from './components/OrderNotifier';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <div className="App min-h-screen bg-background">
            <OrderNotifier />
            <Navbar />
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/menu" element={<MenuPage />} />
              <Route path="/cart" element={<CartPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/signup" element={<SignupPage />} />
              <Route path="/dashboard" element={<UserDashboard />} />
              <Route path="/order/:orderId" element={<OrderTrackingPage />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/qr-codes" element={<QRCodePage />} />
            </Routes>
            <Toaster position="top-center" richColors />
            <Footer />
          </div>
          
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;